import { Platform } from 'react-native';

const platform = Platform.OS;

export const adUnits = (() => {
    const platformSpecificUnits = {
        android: {
            homepageActiveAdUnitId: '/23198695442/kisan_app/homepage_active_feed_companion_ad',
            weatherUnitId: '/23198695442/kisan_app/homepage_infeed_top',
            feedpageVideoPlayerAd:'/23198695442/kisan_app/feedpage_video_player_ad',
            shortsUnitId: '/23198695442/kisan_app/shorts_adunit'
        },
        ios: {
            homepageActiveAdUnitId: '/23198695442/kisan_app/homepage_active_feed_companion_ad',
            weatherUnitId: '/23198695442/kisan_app/ios/homepage_infeed_top',
            feedpageVideoPlayerAd:'/23198695442/kisan_app/feedpage_video_player_ad',
            shortsUnitId: '/23198695442/kisan_app/shorts_adunit'
        },
        web: {
            homepageActiveAdUnitId: '/23198695442/kisan_msite/homepage_active_feed_companion_ad_msite',
            weatherUnitId: '/23198695442/kisan_msite/homepage_infeed_top_msite',
            feedpageVideoPlayerAd:'/23198695442/kisan_msite/feedpage_video_player_ad_msite',
            shortsUnitId: '/23198695442/kisan_msite/shorts_adunit_msite'
        },
    };

    return platformSpecificUnits[platform];
})();
